const projectQueryKeys = {
  projectGroup: (projectGroupHash: string | null): string[] => [
    `projectGroup: ${projectGroupHash}`,
  ],
  project: (projectHash: string | null): string[] => [
    `project: ${projectHash}`,
  ],
  projects: (
    projectHashes: string[] | null,
    promoleadOrgId: number | undefined
  ): string[] => [
    projectHashes ? `${[...projectHashes.sort()]}` : '',
    promoleadOrgId ? `${promoleadOrgId}` : '',
  ],
};

export default projectQueryKeys;
